//工具函数 _ 高仿lodash underscore
(()=>{
    let root = window || global;
    let _ = function(obj) {
        if (obj instanceof _) return obj;
        if (!(this instanceof _)) return new _(obj);
        this._wrapped = obj;
    };
    let [ArrayProto, ObjProto] = [Array.prototype, Object.prototype];

    let [judgeArray]= [Array.isArray];

    let toString = (obj) => ObjProto.toString.call(obj);
    root._ = _;
    [_.forEach, _.map,] = [ArrayProto.forEach, ArrayProto.map];
    //遍历
    _.each = (eArr,callback)=>{
        for(let i in eArr){
            callback(eArr[i], i, eArr)
        }
        return eArr
    }
    //对数组对象进行排序
    _.sortBy = (orderArr, iteratee)=>{
        let keysArr = [];
        let res;
        if(judgeArray(orderArr)){
            //对象数组时[{name:'a',age:1}]
            if(toString(iteratee) === '[object String]'){
                let names  = [];
                let res = [];
                //根据关键字筛选出key数组并排序
                _.each(orderArr, (val, index, arr)=>{
                    names.push(val[iteratee])
                })
                names = _.babble(names);
                //根据排序后key数组跟源数组比较排序
                for(let i=0;i< names.length;i++) {
                    _.each(orderArr, (val, index, arr)=>{
                        if(names[i] == val[iteratee]){
                            res.push( val)
                        }
                    })
                    if(res.length === names.length)break;
                }
            }else{
                //待实现
                return orderArr

            }
        }else if(toString(orderArr) === '[object Object]'){
            //根据对象的key排序 {2:'a',1:'c'}
            res = {};
            keysArr = _.babble(Object.keys(orderArr));
            _.each(keysArr,(val, index, arr)=>{
                res[val] = orderArr[val]
            })
        }else{
            console.warn("请传入key=>value形式")
            return orderArr
        }
        return res
    }
    //冒泡排序
    _.babble = function(arr){
        var length = arr.length;
        var sortArray;
        for (var i = 0; i < length-1; i++) {
            for (var j = 0; j < length-i-1 ; j++) {
                if (arr[j] > arr[j+1]) {
                    [arr[j], arr[j+1]] = [arr[j+1], arr[j]]
                }
            }
        }
        return arr;
    }
    //将对象转为数组对象 {'1':'天气'} => [{id:'1',name:'天气'}]
    _.transformObj = function(obj){
        let transObj = [];
        _.each(obj, (val, index, arr)=>{
            transObj.push({
                id: index,
                name: val
            })
        })
        return transObj
    }
  //获取日期，如昨天 明天 后台
    _.GetDateStr = function(AddDayCount) {
        let dd = new Date();
        dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
        let y = dd.getFullYear();
        let m = dd.getMonth()+1;//获取当前月份的日期
        let d = dd.getDate();
        m = m<10 ? '0'+m : m;
        d = d <10 ? '0'+d : d;

        return y+"-"+m+"-"+d;
    }
    //时间戳转换成日期格式
    _.TimestampToTime = function(date, fmt) {
        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
        }
        let o = {
            'M+': date.getMonth() + 1,
            'd+': date.getDate(),
            'h+': date.getHours(),
            'm+': date.getMinutes(),
            's+': date.getSeconds()
        };
        for (let k in o) {
            if (new RegExp(`(${k})`).test(fmt)) {
                let str = o[k] + '';
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : _.padLeftZero(str));
            }
        }
        return fmt;
    }
    //对比时间间隔是否合格
    _.compareRangeTime = function(startTime,endTime,rangeTime){
        let oneTime = new Date().setTime(new Date(startTime).getTime());
        let twoTime = new Date().setTime(new Date(endTime).getTime());

        if( oneTime + 3600 * 1000 * 24 * rangeTime < twoTime){
            return false;
        } else {
            return true;
        }
    }
    _.padLeftZero = function (str) {
        return ('00' + str).substr(str.length);
    }

})()






// WEBPACK FOOTER //
// ./src/assets/js/config.js